export const conversationsQueryKeys = {
  all: () => ['conversations'],
};
